var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "pwr" }, [
            _c("div", { staticClass: "lft" }, [
              _c("span", { staticClass: "dots" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rgt" }, [
              _c("span", { staticClass: "caption ft-xbld txt-grt" }, [
                _vm._v("Powered by"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "cr ft-bld" }, [
            _c("span", [
              _vm._v("© 2022 Alpha Networks. All rights reserved worldwide"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "spr" }, [_vm._v("|")]),
            _vm._v(" "),
            _c("span", { staticClass: "txt-grt" }, [_vm._v("Privacy Policy")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }